const mutations = {
  SET_SELECTED_TAB(state, payload) {
    state.selectedTab = payload;
  },
  SET_NAVS(state, payload) {
    state.nav = [...payload];
  },
  RECONSTRUCT_TAB(state) {
    state.nav = state.nav.filter((el) => el.status !== "hidden");
  },
  SET_PATIENT_DATA(state, payload) {
    state.patientData = { ...payload };
  },
  SET_CAN_MANAGE_PATIENT(state, payload) {
    state.canManagePatient = payload;
  },
  SET_RESPONSE_DATA(state, payload) {
    state.content = { ...payload.content };
    state.logic = { ...payload.logic };
    state.options = { ...payload.options };
  },
  SET_GET_LOADING(state, payload) {
    state.getDataLoading = payload;
  },
  SET_UPDATE_LOADING(state, payload) {
    state.updateDataLoading = payload;
  },
  SET_SAVE_LOADING(state, payload) {
    state.saveDataLoading = payload;
  },
  SET_GET_DATA_SUCCESS(state, payload) {
    state.getDataSuccess = payload;
  },
  SET_SEQUENCE_NUMBER(state, payload) {
    state.sequenceNumber = payload;
  },
  SET_VISIT_TAB(state, payload) {
    state.selectedTab = payload;
  },
  SET_PATIENT_REF(state, payload) {
    state.patientRef = payload;
  },
  SET_DISABLED_FORM(state, payload) {
    state.disabledForm = payload;
  }
};

export default mutations;
